import { useEffect } from 'react';
import { navigate } from "@reach/router"

const Covid19CleaningPage = () => {
  useEffect(() => {
    navigate('/solutions/use-cases/daily-health-checks/');
  }, []);
  return null;
};

export default Covid19CleaningPage;